exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hotel-image{background-size:cover;position:relative;height:180px;width:100%}.hotel-image__gallery-btn{cursor:pointer;position:absolute;top:10px;right:10px}.hotel-city,.hotel-name{font-weight:600;font-size:1.25rem;color:#fff;position:absolute;left:10px;text-shadow:0 0 3px #000}.hotel-city{top:20px;font-size:1rem}.hotel-name{bottom:10px}.noActualHotelSlot{position:absolute;top:0}body[dir=rtl] .hotel-image__gallery-btn {\n  left: 10px;\n}body[dir=rtl] \n.hotel-city,body[dir=rtl] .hotel-name {\n  right: 10px;\n}\n", ""]);

// exports
